
export default {
	props: {
		frontContent: {
			type: String,
			required: true,
		},
		backContent: {
			type: String,
			required: true,
		},
		imageContent: {
			type: String,
			required: false,
			default: "",
		},
		color: {
			type: String,
			required: true,
		},
		dynamicTextSize: {
			type: Boolean,
			default: false,
		},
		isRevealed: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		isSmallText() {
			return this.dynamicTextSize && this.frontContent.length >= 7;
		},
		isExtraSmallText() {
			return this.dynamicTextSize && this.frontContent.length >= 9;
		},
	},
	methods: {
		revealCard() {
			this.$emit("reveal");
		},
	},
};
